import { ICouponInformationPayload, IPlan, ISubscription, ISubscriptionsState } from '@/@types'

import { MutationTree } from 'vuex'

const mutations: MutationTree<ISubscriptionsState> = {
  RECURLY_TOKEN_UPDATED: (state, token: string) => {
    state.recurlyToken = token
  },
  RECURLY_ACTION_TOKEN_ID_UPDATED: (state, token: string) => {
    state.recurlyTokenActionId = token
  },
  RECURLY_ACTION_TOKEN_RESULT_UPDATED: (state, token: string) => {
    state.recurlyTokenActionResult = token
  },
  PARTNER_STACK_FLOW_UPDATED: (state, isInPartnerFlow: boolean) => {
    state.isInPartnerFlow = isInPartnerFlow
  },
  THREE_DS_FLOW_UPDATED: (state, isIn3dsFlow: boolean) => {
    state.isIn3dsFlow = isIn3dsFlow
  },
  PAYMENT_ENTRIES_UPDATED: (state, entryAndValue: { value: string; input: string }) => {
    const { value, input } = entryAndValue
    state.paymentEntries[value] = input
  },
  CHECKOUT_DISCOUNT_UPDATED: (state, checkoutDiscount: string) => {
    state.checkoutDiscount = checkoutDiscount
  },
  CHECKOUT_COUPON_DISCOUNT_UPDATED: (state, checkoutCouponDiscount: string) => {
    state.checkoutCouponDiscount = checkoutCouponDiscount
  },
  RECURLY_PRICING_UPDATED: (state, recurlyPricing: object) => {
    state.recurlyPricing = recurlyPricing
  },
  CHECKOUT_TAXES_UPDATED: (state, checkoutTaxes: string) => {
    state.checkoutTaxes = checkoutTaxes
  },
  CHECKOUT_SUBTOTAL_UPDATED: (state, checkoutSubtotal: string) => {
    state.checkoutSubtotal = checkoutSubtotal
  },
  CHECKOUT_TOTAL_UPDATED: (state, checkoutTotal: string) => {
    state.checkoutTotal = checkoutTotal
  },
  PAYMENT_METHOD_UPDATED: (state, paymentMethod: string) => {
    state.paymentMethod = paymentMethod
  },
  PROMOTIONAL_FIELD_UPDATED: (state, promotionalField: string) => {
    state.promotionalField = promotionalField
  },
  PAYMENT_METHOD_ON_FILE_UPDATED: (state, paymentMethod: string) => {
    state.paymentMethodOnFile = paymentMethod
  },
  USERS_CURRENT_SUBSCRIPTIONS_UPDATED: (state, usersCurrentSubscriptions: Array<IPlan>) => {
    state.usersCurrentSubscriptions = usersCurrentSubscriptions
  },
  USER_HAS_SUBSCRIPTION_UPDATED: (state, userHasSubscription: boolean) => {
    state.userHasSubscription = userHasSubscription
  },
  USER_HAS_SKILL_DIVE_UPDATED: (state, userHasSkillDive: boolean) => {
    state.userHasSkillDive = userHasSkillDive
  },
  USER_SUBSCRIPTIONS_WITH_PASSES_UPDATED: (
    state,
    usersCurrentSubscriptionsWithPasses: Array<ISubscription>
  ) => {
    state.usersCurrentSubscriptionsWithPasses = usersCurrentSubscriptionsWithPasses
  },
  COUPON_INFORMATION_UPDATED: (state, couponInformation: ICouponInformationPayload) => {
    state.couponInformation = couponInformation
  },
}

export default mutations
